const guardDivisor = (num) => (num > 0 ? num : 1);

export default {
  guardDivisor,
};
